import { AddSVG, InfoSVG, SubtractSVG } from 'src/components/Icons/Basic'
import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { LinkIcon } from 'src/components/Icons/FileType'
import { StyledTextButton } from '../Buttons/TextButton/TextButton'

export const MappingsContainer = styled.div`
  padding: 20px;
`

export const MappingsSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`

export const MappingsAddIcon = styled(AddSVG)<{
  $disabled?: boolean
}>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  &:hover {
    cursor: pointer;
  }
  ${({ $disabled }) =>
    $disabled &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  `}
`

export const MappingsMinusIcon = styled(SubtractSVG)<{
  $disabled?: boolean
}>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  &:hover {
    cursor: pointer;
  }
  ${({ $disabled }) =>
    $disabled &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  `}
`

export const MappingsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 16px;
  margin-bottom: 8px;
`
export const MappingsSectionCTA = styled(StyledTextButton)`
  display: flex;
  justify-content: flex-start;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  margin-left: 32px;
  margin-bottom: 8px;
  color: ${palette.blue[600]};
  cursor: pointer;
`

export const MappingsSectionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
`

export const MappingInfoIcon = styled(InfoSVG)`
  width: 16px;
  height: 16px;
`

export const MappingsSubsectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  margin-bottom: 5px;
`

export const MappingLinkButton = styled(LinkIcon)`
  width: 14px;
  height: 14px;
  path {
    fill: ${palette.neutral[600]};
  }
  &:hover {
    cursor: pointer;
    path {
      fill: ${palette.neutral[300]};
    }
  }
`
